/**
 * Tracking
 */

export class Event {
  constructor(data = {}) {
    this.event = {}
    this.event.name = data.name || null
    // Remove name from payload (if it exists) and add data
    if (data.name) {
      delete data.name
    }
    this.event.data = Object.assign({}, data)
  }

  set(key, val) {
    if (key === 'name') {
      this.event.name = val
      return this.event
    }
    this.event.data[key] = val
    return this.event
  }

  publish() {
    if (!this.event.name) {
      throw new Error(`An event tracking name param is required`)
    }

    // gtag.js is attached to window in index.html: widown.gtag
    if (window.gtag) {
      window.gtag('event', this.event.name, this.event.data)
    }
  }
}
